import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-taxallocation-2",
  "use": "icon-soc-m-taxallocation-2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-taxallocation-2\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"660\" cy=\"280\" r=\"28\" /><circle cx=\"512\" cy=\"512\" r=\"320\" /><path d=\"M480 288h64v96h-64zM416 416h192v64H416zM416 544h192v64H416zM480 640h64v96h-64z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-taxallocation-2.svg
// module id = JhIb
// module chunks = 546